import {FileTs} from "../../../model/models";
import {UtilsService} from "../../../services/Utils.service";

export const detailModalColumns = [
    {
        title: "Codice esenzione",
        dataIndex: "exemptionCode",
        key: "exemptionCode",
    },
    {
        title: "Anno",
        dataIndex: "year",
        key: "year",
    },
    {
        title: "Importo ticket",
        key: "totalTicket",
        render: (record: FileTs) => "€ " + UtilsService.formatNumber(record.totalTicket),
    },
    {
        title: "Interessi",
        key: "totalInterest",
        render: (record: FileTs) =>
            record.totalInterest > 0 ? "€ " + UtilsService.formatNumber(record.totalInterest) : "No",
    },
    {
        title: "Importo totale",
        key: "totalSum",
        render: (record: FileTs) => {
            const totalSum = record.totalTicket || 0;
            const interests = record.totalInterest || 0;
            const total = totalSum + interests;
            return `€ ${UtilsService.formatNumber(total)}`;
        },
    },
];